import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import img from '../Assets/aryaa_logo.png';

function Header() {
  const [activeTab, setActiveTab] = useState('home');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Set the active tab based on the current path
    switch (location.pathname) {
      case '/about':
        setActiveTab('about-us');
        break;
      case '/product_page':
        setActiveTab('our-product');
        break;
      case '/contact':
        setActiveTab('contact-us');
        break;
      default:
        setActiveTab('home');
    }
  }, [location.pathname]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setIsMobileMenuOpen(false); // Close the mobile menu when a tab is clicked
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className='z-1 bg-transparent font-secondary'>
      <div className="header">
        <Link to="/">
          <img src={img} alt="Logo" className="logo" onClick={() => handleTabClick('home')} />
        </Link>
        
        <div className="nav-toggle" onClick={toggleMobileMenu}>
          <div className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}></div>
        </div>
        <ul className={`nav-list ${isMobileMenuOpen ? 'open' : ''}`}>
        <Link to="/" className="nav-link">
          <li
            className={activeTab === 'home' ? 'active' : ''}
            onClick={() => handleTabClick('home')}
          >
           HOME
          </li>
          </Link>
          <Link to="/about" className="nav-link">
          <li
            className={activeTab === 'about-us' ? 'active' : ''}
            onClick={() => handleTabClick('about-us')}
          >
            ABOUT US
          </li>
          </Link>
          <Link to="/product_page" className="nav-link">
          <li
            className={activeTab === 'our-product' ? 'active' : ''}
            onClick={() => handleTabClick('our-product')}
          >
            OUR PRODUCTS
          </li>
          </Link>
          <Link to="/contact" className="nav-link">
          <li
            className={activeTab === 'contact-us' ? 'active' : ''}
            onClick={() => handleTabClick('contact-us')}
          >
            CONTACT US
          </li>
          </Link>
        </ul>
      </div>
    </nav>
  );
}

export default Header;